import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "selectedUsers", "selectedInstructors", "instructorField", "defaultAlert", "resendAlert", "instructorName", "subject", "ccUsers", "submitButton", "scheduleButton"]

  connect() {
    this.setupDropdownBehavior()
  }

  disconnect() {
    // Remove event listeners to prevent memory leaks
    const dropdownMenu = this.element.querySelector('.dropdown-menu')
    if (dropdownMenu && this.boundStopPropagation) {
      dropdownMenu.removeEventListener('click', this.boundStopPropagation)
    }
  }

  setupDropdownBehavior() {
    // Prevent dropdown from closing when clicking inside the dropdown menu
    const dropdownMenu = this.element.querySelector('.dropdown-menu')
    if (dropdownMenu) {
      // Store bound method as instance property for proper cleanup
      this.boundStopPropagation = (event) => {
        // Don't stop propagation for modal triggers - let Bootstrap handle them
        if (event.target.closest('[data-toggle="modal"]')) {
          return
        }
        event.stopPropagation()
      }
      dropdownMenu.addEventListener('click', this.boundStopPropagation)
    }
  }

  populateModal(event) {
    event.preventDefault()

    const link = event.currentTarget
    const resend = link.dataset.resend === "true" ? true : false
    const studentNames = link.dataset.studentNames || ""
    const instructorNameValue = link.dataset.instructorName || ""
    const studentIds = link.dataset.studentIds || ""
    const instructorId = link.dataset.instructorId || ""
    const titleElement = this.modalTarget.querySelector('#exampleModalCenterTitle')

    // Always set button text to "Send Now" when modal opens
    this.submitButtonTarget.textContent = "Send Now"

    // Unhide/hide elements and update text pertinent to resends
    if (resend === true) {
      titleElement.innerText = 'Resend Travel Letter Message'
      this.instructorFieldTarget.style.display = 'block';
      this.resendAlertTarget.style.display = 'block'
      this.defaultAlertTarget.style.display = 'none'
      this.instructorFieldTarget.querySelector('input').value = instructorNameValue
      this.scheduleButtonTarget.style.display = 'none'
      this.submitButtonTarget.style.borderTopRightRadius = '8px'
      this.submitButtonTarget.style.borderBottomRightRadius = '8px'

      // Clear deliver_at field
      const deliverAtField = this.modalTarget.querySelector('input[name="deliver_at"]')
      if (deliverAtField) {
        deliverAtField.value = ''
        // If using flatpickr, also clear its internal state
        if (deliverAtField._flatpickr) {
          deliverAtField._flatpickr.clear()
        }
      }
    } else {
      titleElement.innerText = 'Send Travel Letter Message'
      this.instructorFieldTarget.style.display = 'none';
      this.defaultAlertTarget.style.display = 'block'
      this.resendAlertTarget.style.display = 'none'
      this.scheduleButtonTarget.style.display = 'block'
      this.submitButtonTarget.style.borderTopRightRadius = '0'
      this.submitButtonTarget.style.borderBottomRightRadius = '0'
    }

    const selectedUsersContainer = this.selectedUsersTarget
    if (selectedUsersContainer) {
      selectedUsersContainer.innerText = ''

      if (studentNames) {
        if (studentNames.split(',').length > 0) {
          selectedUsersContainer.innerHTML = '<label><strong>Impacted Students</strong></label>'

          const cardBody = document.createElement('div')
          selectedUsersContainer.appendChild(cardBody)

          const studentItem = document.createElement('div')
          studentItem.innerHTML = `
            <span>${studentNames}</span>
          `
          cardBody.appendChild(studentItem)
        }
      }

      if (studentIds) {
        const studentIdArray = studentIds.split(',').map(id => id.trim())
        studentIdArray.forEach(studentId => {
          if (studentId) {
            const studentIdsField = document.createElement('input')
            studentIdsField.type = 'hidden'
            studentIdsField.name = 'included_student_ids[]'
            studentIdsField.value = studentId
            selectedUsersContainer.appendChild(studentIdsField)
          }
        })
      }
    }

    const selectedInstructorsContainer = this.selectedInstructorsTarget
    if (instructorId) {
      const instructorIdsField = document.createElement('input')
      instructorIdsField.type = 'hidden'
      instructorIdsField.name = 'messaged_teacher_ids[]'
      instructorIdsField.value = instructorId
      selectedInstructorsContainer.appendChild(instructorIdsField)
    }

    $(this.modalTarget).modal('show')
  }

  updateButtonText(event) {
    const submitButton = this.submitButtonTarget
    if (event.target.value) {
      submitButton.textContent = "Schedule Message"
    } else {
      submitButton.textContent = "Send Message"
    }
  }
}
